import crudHandlers from './_crud'

const initialState = {
	clients: [],
	amount: 0,
	customerOrders: [],
	ordersError: null,
}

export default (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case 'LOAD_CLIENTS': {
			return {
				...state,
				clients: action.response ?? []
			}
		}
		case 'LOAD_AMOUNT_OF_CLIENTS': {
			return {
				...state,
				amount: typeof payload == 'number' ? payload : 0 
			}
		}
		case "LOAD_CUSTOMER_ORDERS_SUCCESS": {
		return {
			...state,
			customerOrders: action.payload.body,
			ordersError: null,
		};
		}
		default:
			state = crudHandlers(state, action, 'client')

			return state
	}
}
